e4.handlebars = {
    debug: false,
    init: function () {
    },
    getTemplateName: function ( strTemplateSelector ) {
        return jQuery.camelCase( strTemplateSelector.substring( 1 ).replace( 'js-e-handlebars-tmpl-', '' ) );
    },
    compileTemplate: function ( strTemplateSelector, boolIsPartial ) {
        var tmplName = e4.handlebars.getTemplateName( strTemplateSelector ),
            jTmpl = jQuery( strTemplateSelector ).first(),
            strTmplHtml = jTmpl.html();
        if ( jTmpl.length === 1 ) {
            if ( boolIsPartial === true ) {
                Handlebars.registerPartial( tmplName, strTmplHtml );
                e4.handlebars.partial[ tmplName ] = Handlebars.compile( strTmplHtml );
            }
            else {
                e4.handlebars.tmpl[ tmplName ] = Handlebars.compile( strTmplHtml );
            }
        }
    },
    tmpl: {},
    registerTemplates: function ( strTemplates ) {
        var arrTemplates = strTemplates.split( ' ' );
        for ( var i = 0; i < arrTemplates.length; i++ ) {
            e4.handlebars.compileTemplate( arrTemplates[ i ] );
        }
    },
    partial: {},
    registerPartials: function ( strPartials ) {
        var arrPartials = strPartials.split( ' ' );
        for ( var i = 0; i < arrPartials.length; i++ ) {
            e4.handlebars.compileTemplate( arrPartials[ i ], true );
        }
    },
    registerHelpers: function ( strHelpers ) {
        var arrHelpers = strHelpers.split( ' ' );
        for ( var i = 0; i < arrHelpers.length; i++ ) {
            if ( window.Handlebars.helpers[ arrHelpers[ i ] ] === undefined ) {
                e4.handlebars.helpers[ arrHelpers[ i ] ]();
            }
        }
    },
    helpers: {
        /* jshint ignore:start */
        compare: function () {
            Handlebars.registerHelper( 'compare', function ( v1, operator, v2, options ) {
                return e4.handlebars.helpers.testValue( v1, operator, v2 ) ? options.fn( this ) : options.inverse( this );
            } );
        },
        testValue: function ( v1, operator, v2 ) {
            switch ( operator ) {
            case '===':
                return ( v1 === v2 );
            case '!==':
                return ( v1 !== v2 );
            case '<':
                return ( v1 < v2 );
            case '<=':
                return ( v1 <= v2 );
            case '>':
                return ( v1 > v2 );
            case '>=':
                return ( v1 >= v2 );
            case '&&':
                return ( v1 && v2 );
            case '||':
                return ( v1 || v2 );
            case '!!':
                return ( !v1 && !v2 );
            case '!|':
                return ( !v1 && v2 );
            case '|!':
                return ( v1 && !v2 );
            case '%':
                return ( v1 % v2 === 0 );
            default:
                return false;
            }
        },
        compare_extended: function () {
            Handlebars.registerHelper( 'compare_extended', function ( v1, operator, v2, options ) {
                if ( v2.indexOf( ',' ) > -1 ) {
                    // v2 is array - extend compare-function
                    var v2Arr = v2.split( ',' ),
                        v2ReturnArr = [];
                    // iterate v2-array and test each value, adding the returned boolean to a temp array
                    for ( var i = 0; i < v2Arr.length; i++ ) {
                        v2ReturnArr.push( e4.handlebars.helpers.testValue( v1, operator, v2Arr[ i ] ) );
                    }
                    // test temp array values, returning true if all values are the same, eg. [true,true] or
                    // [false,false]
                    if ( operator === '===' ) {
                        return ( v2ReturnArr.indexOf( true ) > -1 ) === true ? options.fn( this ) : options.inverse( this );
                    }
                    return v2ReturnArr.every( function ( val ) {
                        return val;
                    } ) === true ? options.fn( this ) : options.inverse( this );
                }
                else {
                    // v2 is string - standard compare function
                    return e4.handlebars.helpers.testValue( v1, operator, v2 ) ? options.fn( this ) : options.inverse( this );
                }
            } );
        },
        /* jshint ignore:end */
        counter: function () {
            Handlebars.registerHelper( 'counter', function ( index ) {
                return index + 1;
            } );
        },
        /* jshint ignore:end */
        addX: function () {
            Handlebars.registerHelper( 'addX', function () {
                var intArrAdd = Array.prototype.slice.call(arguments,0,-1);
                return intArrAdd.reduce(function(a,b) {
                    return a + b;
                }, 0);
            } );
        },
        isLightOrDarkBg: function () {
            Handlebars.registerHelper( 'isLightOrDarkBg', function ( strHexColor ) {
                var hex = strHexColor.replace( '#', '' ),
                    c_r = parseInt( hex.substr( 0, 2 ), 16 ),
                    c_g = parseInt( hex.substr( 2, 2 ), 16 ),
                    c_b = parseInt( hex.substr( 4, 2 ), 16 ),
                    brightness = ( ( c_r * 299 ) + ( c_g * 587 ) + ( c_b * 114 ) ) / 1000;

                if ( brightness > e4.settings.handlebars.helpers.isLightOrDarkBg.limit ) {
                    return 'is-light-background';
                }
                else {
                    return 'is-dark-background';
                }
            } );
        },
        contains: function () {
            Handlebars.registerHelper( 'contains', function ( needle, haystack, options ) {
                needle = Handlebars.escapeExpression( needle );
                haystack = Handlebars.escapeExpression( haystack );
                return ( haystack.indexOf( needle ) > -1 ) ? options.fn( this ) : options.inverse( this );
            } );
        },
        toJSON: function () {
            Handlebars.registerHelper( 'toJSON', function ( object ) {
                return  JSON.stringify( object, {
                    noEscape: true
                } ) ;
            } );
        },
        replace: function () {
            Handlebars.registerHelper( 'replace', function ( str, searchvalue, newValue ) {
                return str.replace(searchvalue, newValue);
            } );
        },
        getFieldgroupTranslations: function(){
            Handlebars.registerHelper( 'getFieldgroupTranslations', function ( key, nestedKey ) {
                var dataTranslations = {};
                if(key === 'Washing'){
                    dataTranslations = window.careSymbolsWashingTranslated;
                    return dataTranslations[nestedKey];
                } else{
                    dataTranslations = window.careSymbolsTranslated;
                    return dataTranslations[key];
                }
            } );
        },
        calculateFreeFreightOnCustomershop:function(){
            Handlebars.registerHelper( 'calculateFreeFreightOnCustomershop', function ( current, limit ) {
                var calc = Math.ceil((current / limit) * 100);
                if(calc < 0){
                    calc = 0;
                } else if(calc > 100){
                    calc = 100;
                }
                return calc;
            } );
        },
        HasFreeFreightOnCustomershop:function(){
            Handlebars.registerHelper( 'HasFreeFreightOnCustomershop', function ( current, limit, options ) {
                return current >= limit ? options.fn( this ) : options.inverse( this );
            } );
        },
        hasRelatedProductOrderline:function(){
            Handlebars.registerHelper( 'hasRelatedProductOrderline', function ( orderlines, productId, options ) {
                var relatedOrderline = orderlines.find( ol => ol.customerShopRelatedProductId === productId);
                return relatedOrderline ? options.fn( this ) : options.inverse( this );
            } );
        },
        getRelatedProductOrderlineId:function(){
            Handlebars.registerHelper( 'getRelatedProductOrderlineId', function ( orderlines, productId ) {
                var relatedOrderline = orderlines.find( ol => ol.customerShopRelatedProductId === productId);
                return relatedOrderline ? relatedOrderline.id : null;
            } );
        },
        getDesignOrderLineGroupProductCount:function(){
            Handlebars.registerHelper( 'getDesignOrderLineGroupProductCount', function ( group ) {
                return group.reduce((accumulator, orderLine) => accumulator + orderLine.quantity, 0);
            } );
        }
    }
};

